import { render } from "./visitRecords.vue?vue&type=template&id=fdeb1de8&scoped=true"
import script from "./visitRecords.vue?vue&type=script&lang=js"
export * from "./visitRecords.vue?vue&type=script&lang=js"

import "./visitRecords.vue?vue&type=style&index=0&id=fdeb1de8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdeb1de8"]])

export default __exports__